import { createContext, Dispatch, SetStateAction } from 'react';

interface TableCellDragAndDropContextValue {
  loadingCellIds: string[];
  setLoadingCellIds: Dispatch<SetStateAction<string[]>>;
}

export default createContext<TableCellDragAndDropContextValue | null>(null);
